/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Pool_All_PlayersInputs */



/**
* | output |
* | --- |
* | "All players" |
*
* @param {Raffle_Pool_All_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_pool_all_players = /** @type {((inputs?: Raffle_Pool_All_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Pool_All_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i giocatori")
	return /** @type {LocalizedString} */ ("All players")
});